import { Star, ShieldCheck, Calculator } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { SearchBar } from "@/components/site/SearchBar";

export function Hero() {
  return (
    <section className="relative overflow-hidden bg-[#0B1120] min-h-screen flex flex-col">
      {/* Dark gradient glow with brand accent */}
      <div
        aria-hidden
        className="absolute inset-x-0 -top-32 h-[600px] bg-[radial-gradient(ellipse_at_top,theme(colors.primary/25%),transparent_55%)] pointer-events-none"
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,theme(colors.primary/10%),transparent_50%)] pointer-events-none"
      />

      <div className="container mx-auto max-w-7xl px-4 sm:px-6 py-12 sm:py-24 relative flex flex-col justify-center flex-1">
        <div className="flex flex-col items-center text-center">

          <h1 className="font-display font-bold text-5xl sm:text-6xl md:text-7xl tracking-tight leading-[1.05] max-w-4xl text-white">
            El portal inmobiliario{" "}
            <span className="text-primary">exclusivo</span>{" "}
            para negocios
          </h1>

          <div className="w-full mt-12 min-h-[320px] sm:min-h-[240px] md:min-h-[200px]">
            <SearchBar />
          </div>

          <p className="-mt-5 text-lg sm:text-xl text-white/70 max-w-2xl">
            La opción inteligente para encontrar, traspasar, vender o alquilar locales
            comerciales.
          </p>

          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/60">
            <span className="inline-flex items-center gap-1.5">
              <span className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 fill-primary text-primary" />
                ))}
              </span>
              <span className="font-semibold text-white">4,9/5</span>
              <span>de 2320+ negocios</span>
            </span>
            <span className="hidden sm:inline text-white/30">•</span>
            <span className="inline-flex items-center gap-1.5">
              <ShieldCheck className="h-4 w-4 text-primary" />
              Contactos verificados
            </span>
          </div>

          <Button
            size="lg"
            className="mt-8 rounded-full bg-primary text-primary-foreground hover:bg-primary/90"
            asChild
          >
            <Link to="/estimador">
              <Calculator className="mr-2 h-5 w-5" />
              Calcula el valor de tu negocio
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
